import { Injectable, inject } from '@angular/core';

import { GraphQLRepository } from '@repositories/graphql.repository';

import { Banner } from '@interfaces/directus-cms.interface';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BannersService {
    protected graphQLRepository: GraphQLRepository = inject(GraphQLRepository);

    public getBannersForSlug(querySlugParam: string): Observable<Banner> {
        return this.graphQLRepository.getBannersForSlug(querySlugParam);
    }
}
